import { LoaderCircle } from "lucide-react"
import cn from "@/v2-ui/utils/utils.cn"
import {
  Switch as SwitchBase,
  type SwitchProps as SwitchBaseProps,
} from "@/v2-ui/switch/base/SwitchBase"

export type SwitchProps = SwitchBaseProps & {
  isLoading?: boolean
}

function Switch(props: SwitchProps) {
  const { isLoading, className, disabled, ...switchBaseProps } = props

  return (
    <div
      className={cn(
        "ui-switch-wrapper",
        className,
        isLoading && "ui-switch-is-loading",
      )}
    >
      <SwitchBase disabled={disabled || isLoading} {...switchBaseProps} />
      {isLoading && <LoaderCircle className="ui-switch-loader animate-spin" />}
    </div>
  )
}

export default Switch
